import React, { FC } from 'react'
import clsx from 'clsx'
import { makeStyles, Theme } from '@material-ui/core/styles'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Link as MuiLink,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import messages from '../../messages'
import { FormattedMessage, useIntl } from 'react-intl'
import { ProductType } from '../../products/Ngso/enum'

const useStyles = makeStyles((theme: Theme) => ({
  content: {
    padding: theme.spacing(0, 8, 4, 8),
    fontSize: theme.typography.pxToRem(16),
  },
  title: {
    padding: theme.spacing(2),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.pxToRem(20),
    textTransform: 'uppercase',
  },
  actions: {
    padding: theme.spacing(4, 8, 8, 4),
  },
  closeButton: {
    padding: 0,
    color: theme.palette.common.black,
    fontSize: theme.typography.pxToRem(16),
  },
  cancel: {
    paddingRight: theme.spacing(4),
    cursor: 'pointer',
  },
  borderRaduis: {
    '& .MuiPaper-rounded': {
      borderRadius: 0,
    },
  },
}))

interface ConfirmRemovalProps {
  dialogOpen: boolean
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>
  onDelete: any
  selectedItem: any
  type: any
  confirmRemoval: any
  productType: any
}
let titleMsg = ''
let msg = ''
let buttonText = ''

const ConfirmRemovalPopup: FC<ConfirmRemovalProps> = (props) => {
  const classes = useStyles()
  const intl = useIntl()
  const {
    dialogOpen,
    setDialogOpen,
    onDelete,
    selectedItem,
    type,
    confirmRemoval,
    productType,
  } = props

  const handleClose = () => {
    setDialogOpen(false)
  }
  if (type === 'All') {
    if (confirmRemoval) {
      titleMsg = intl.formatMessage(
        messages.CONF_NGSO_COMFIRM_REMOVAL_POPUP_HEADING
      )
      if (productType === ProductType.NgsoTubes) {
        msg = intl.formatMessage(
          messages.CONF_NGSO_COMFIRM_REMOVAL_POPUP_TEXT_FOR_TUBES
        )
      } else {
        msg = intl.formatMessage(
          messages.CONF_NGSO_COMFIRM_REMOVAL_POPUP_TEXT_FOR_PLATES
        )
      }
      buttonText = intl.formatMessage(messages.YES)
    } else {
      titleMsg = intl.formatMessage(messages.CONF_DELETE_ALL_ITEM_DNA_PLATES)
      msg = intl.formatMessage(messages.CONF_DELETE_ALL_ITEM_MSG_DNA_PLATES)
      buttonText = intl.formatMessage(
        messages.CONF_DELETE_ALL_BUTTON_TEXT_DNA_PLATES
      )
    }
  } else if (type === 'Selected' || type === 'SelectedViewAll') {
    titleMsg = intl.formatMessage(messages.CONF_DELETE_ITEM_DNA_PLATES)
    msg = intl.formatMessage(messages.CONF_DELETE_ITEM_MSG_DNA_PLATES)
    buttonText = intl.formatMessage(messages.CONF_DELETE_BUTTON_TEXT_DNA_PLATES)
  }

  const handleDelete = () => {
    onDelete(selectedItem, type)
    setDialogOpen(false)
  }

  return (
    <Dialog open={dialogOpen} className={classes.borderRaduis}>
      <DialogTitle>
        <div className={classes.title}>
          {titleMsg}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            className={classes.closeButton}
          >
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent className={clsx(classes.content)}>{msg}</DialogContent>
      <DialogActions className={classes.actions}>
        {confirmRemoval ? (
          <>{console.info('confirm Removal true')}</>
        ) : (
          <MuiLink
            color="primary"
            onClick={() => handleClose()}
            className={classes.cancel}
          >
            <FormattedMessage {...messages.CANCEL} />
          </MuiLink>
        )}
        <Button
          onClick={handleDelete}
          color="primary"
          variant="contained"
          id="delete-all-confirm-button"
          data-testid="delete-all-confirm-button"
        >
          {buttonText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmRemovalPopup
